<template>
  <div class="input-filled-count-label">
    <common-label>
      <template v-slot:contents>
        <div class="aisea-text-12-600-dark-gray my-1">{{ itemLabel }}</div>
        <div class="flex items-center justify-center mt-4">
          <div class="flex items-end text-end">
            <div class="flex items-end mx-6">
              <div class="count-label mr-2">{{ number }}</div>
              <div class="slash-label mr-2">/</div>
              <div class="aisea-text-18-600-dark-gray">{{ maxNumber }}</div>
            </div>
            <div class="aisea-text-18-600-dark-gray">登録</div>
          </div>
        </div>
      </template>
    </common-label>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import CommonLabel from "./CommonLabel.vue";

/*
 * 対応中事故件数
 */
export default {
  name: "M.ClaimCountLabel",
  props: {
    number: {
      type: Number,
      required: true,
    },
    maxNumber: {
      type: Number,
      required: true,
    },
    itemLabel: {
      type: String,
      required: true,
    },
  },
  mixins: [ColorMixin],
  components: {
    CommonLabel,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
.input-filled-count-label {
  .count-label {
    line-height: 1;
    font-size: 40px;
    font-weight: 600;
    font-family: $aisea-font-family;
  }
  .slash-label {
    font-size: 40px;
    line-height: 1;
  }
}
</style>
